class ProjectSelector {
  static BREAKPOINT = '(min-width: 1008px)';

  static init() {
    document.querySelectorAll('[data-project-selector]').forEach((root) => {
      if (root.dataset.projectSelectorReady === 'true') return;
      root.projectSelector = new ProjectSelector(root);
      root.dataset.projectSelectorReady = 'true';
    });
  }

  constructor(root) {
    this.root = root;
    this.tabs = Array.from(root.querySelectorAll('[data-project-selector-tab]'));
    this.panels = Array.from(root.querySelectorAll('[data-project-selector-panel]'));
    this.index = 0;

    if (!this.panels.length) return;

    this.media = window.matchMedia(ProjectSelector.BREAKPOINT);
    this.onBreakpointChange = () => this.sync();

    const follow = (event) => {
      const tab = event.target.closest('[data-project-selector-tab]');
      if (!tab || !this.root.contains(tab)) return;
      this.select(Number(tab.getAttribute('data-project-selector-tab')));
    };

    this.root.addEventListener('mouseover', follow);
    this.root.addEventListener('focusin', follow);

    this.root.addEventListener('keydown', (event) => {
      if (!event.target.closest('[data-project-selector-tab]')) return;

      const step = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 }[event.key];
      if (!step) return;

      event.preventDefault();
      const next = (this.index + step + this.tabs.length) % this.tabs.length;
      this.select(next);
      if (this.tabs[next]) this.tabs[next].focus();
    });

    this.media.addEventListener('change', this.onBreakpointChange);
    this.sync();
  }

  /* Root listeners die with the node; the MediaQueryList one does not. */
  destroy() {
    if (this.media && this.onBreakpointChange) {
      this.media.removeEventListener('change', this.onBreakpointChange);
    }
    if (this.root) {
      delete this.root.dataset.projectSelectorReady;
      this.root.projectSelector = null;
    }
  }

  select(index) {
    if (Number.isNaN(index) || index === this.index) return;
    this.index = index;
    this.sync();
  }

  sync() {
    const isSwitching = this.media.matches;

    this.panels.forEach((panel, index) => {
      const active = index === this.index;

      if (!isSwitching) {
        panel.removeAttribute('data-active');
        panel.removeAttribute('aria-hidden');
        panel.removeAttribute('inert');
        return;
      }

      panel.toggleAttribute('data-active', active);
      panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      panel.toggleAttribute('inert', !active);
    });

    this.tabs.forEach((tab, index) => {
      tab.setAttribute('aria-current', index === this.index ? 'true' : 'false');
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => ProjectSelector.init());
} else {
  ProjectSelector.init();
}

document.addEventListener('shopify:section:load', () => ProjectSelector.init());

document.addEventListener('shopify:section:unload', (event) => {
  if (!event.target || !event.target.querySelectorAll) return;
  event.target.querySelectorAll('[data-project-selector]').forEach((root) => {
    if (root.projectSelector) root.projectSelector.destroy();
  });
});
